import { Routes } from '@angular/router'
import { AuthGuard } from '@shared/guards/auth.guard'
import {
  NgxGfmoneyCreateMessageComponent,
  NgxGfmoneyMessageComponent,
  NgxGfmoneyMessagesComponent,
  NgxGfmoneyMessagesModule,
} from '@yuri.karkhachev/ngx-gfmoney-messages'
import { DashboardLayoutComponent } from '@visa/shared/components/dashboard-layout/dashboard-layout.component'
import { DashboardGuard } from '@shared/guards/dashboard.guard'
import { importProvidersFrom } from '@angular/core'
import { environment } from '@environments/environment'

// istanbul ignore next
export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./flow/shared/flow-layout/flow-layout.component').then(m => m.FlowLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./flow/index-page/index-page.component').then(m => m.IndexPageComponent),
      },
      {
        path: 'bankid-auth',
        loadComponent: () => import('./flow/bankid-auth/bankid-auth.component').then(m => m.BankidAuthComponent),
      },
      {
        path: 'phone-verification',
        loadComponent: () =>
          import('./flow/phone-verification-page/phone-verification-page.component').then(
            m => m.PhoneVerificationPageComponent,
          ),
      },
      {
        path: 'loan-details',
        loadComponent: () => import('./flow/loan-details/loan-details.component').then(m => m.LoanDetailsComponent),
      },
      {
        path: 'consents',
        loadComponent: () => import('./flow/consents/consents.component').then(m => m.ConsentsComponent),
      },
      {
        path: 'customer-details',
        loadComponent: () =>
          import('./flow/customer-details/customer-details.component').then(m => m.CustomerDetailsComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'income-check-overview',
        loadComponent: () =>
          import('./flow/income-check-overview/income-check-overview.component').then(
            m => m.IncomeCheckOverviewComponent,
          ),
      },
      {
        path: 'income-check-init',
        loadComponent: () =>
          import('./flow/income-check-init/income-check-init.component').then(m => m.IncomeCheckInitComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'income-check-status',
        loadComponent: () =>
          import('./flow/income-check-status/income-check-status.component').then(m => m.IncomeCheckStatusComponent),
      },
      {
        path: 'loan-summary',
        loadComponent: () => import('./flow/loan-summary/loan-summary.component').then(m => m.LoanSummaryComponent),
      },
      {
        path: 'contract-sign',
        loadComponent: () => import('./flow/contract-sign/contract-sign.component').then(m => m.ContractSignComponent),
      },
      {
        path: 'bank-validation',
        loadComponent: () =>
          import('./flow/bank-validation/bank-validation.component').then(m => m.BankValidationComponent),
      },
      {
        path: 'bank-validation-fail',
        loadComponent: () =>
          import('./flow/bank-validation-fail/bank-validation-fail.component').then(m => m.BankValidationFailComponent),
      },
      {
        path: 'transactions-check',
        loadComponent: () =>
          import('./flow/transactions-check/transactions-check.component').then(m => m.TransactionsCheckComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'account-selection',
        loadComponent: () =>
          import('./flow/account-selection/account-selection.component').then(m => m.AccountSelectionComponent),
      },
      {
        path: 'scoring-results',
        loadComponent: () =>
          import('./flow/scoring-results/scoring-results.component').then(m => m.ScoringResultsComponent),
      },
      {
        path: 'decision-rejected',
        loadComponent: () =>
          import('./flow/decision-rejected-page/decision-rejected-page.component').then(
            m => m.DecisionRejectedPageComponent,
          ),
      },
      {
        path: 'decision-success',
        loadComponent: () =>
          import('./flow/decision-success-page/decision-success-page.component').then(
            m => m.DecisionSuccessPageComponent,
          ),
      },
      {
        path: 'decision-final',
        loadComponent: () =>
          import('./flow/decision-final/decision-final.component').then(m => m.DecisionFinalComponent),
      },
      {
        path: 'customer-exists',
        loadComponent: () =>
          import('./flow/customer-exists/customer-exists.component').then(m => m.CustomerExistsComponent),
      },
      {
        path: 'brokers/:guid',
        loadComponent: () => import('./flow/brokers/brokers.component').then(m => m.BrokersComponent),
      },
      {
        path: 'resume/:guid',
        loadComponent: () =>
          import('./flow/resume-flow-page/resume-flow-page.component').then(m => m.ResumeFlowPageComponent),
      },
      { path: 'error', loadComponent: () => import('./flow/error/error.component').then(m => m.ErrorComponent) },
      { path: 'pay', loadComponent: () => import('./flow/pay/pay.component').then(m => m.PayComponent) },
      {
        path: 'pay-redirect',
        loadComponent: () => import('./flow/pay-redirect/pay-redirect.component').then(m => m.PayRedirectComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'auth-user/:linkId',
        loadComponent: () => import('./flow/auth-user/auth-user.component').then(m => m.AuthUserComponent),
      },
      {
        path: 'identify',
        loadComponent: () => import('./flow/identify/identify.component').then(m => m.IdentifyComponent),
      },
      {
        path: 'authenticator-results',
        loadComponent: () =>
          import('./flow/authenticator-results/authenticator-results.component').then(
            m => m.AuthenticatorResultsComponent,
          ),
      },
      {
        path: 'create-loan',
        loadComponent: () => import('./flow/create-loan/create-loan.component').then(m => m.CreateLoanComponent),
      },
      {
        path: 'create-loan-denied',
        loadComponent: () =>
          import('./flow/create-loan-denied/create-loan-denied.component').then(m => m.CreateLoanDeniedComponent),
      },
    ],
  },
  {
    path: 'dashboard-visa',
    component: DashboardLayoutComponent,
    children: [
      { path: '', redirectTo: '/dashboard-visa/login', pathMatch: 'full' },
      {
        path: 'login',
        loadComponent: () => import('./dashboard-visa/login-page/login-page.component').then(m => m.LoginPageComponent),
      },
      {
        path: 'setup',
        loadComponent: () => import('./dashboard-visa/setup/setup.component').then(m => m.SetupComponent),
      },
      {
        path: 'transactions',
        loadComponent: () =>
          import('./dashboard-visa/transactions/transactions.component').then(m => m.TransactionsComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'invoices',
        loadComponent: () =>
          import('./dashboard-visa/invoices-page/invoices-page.component').then(m => m.InvoicesViewComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'help',
        loadComponent: () => import('./dashboard-visa/help-page/help-page.component').then(m => m.HelpPageComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'home',
        loadComponent: () => import('./dashboard-visa/home-page/home-page.component').then(m => m.HomePageComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./dashboard-visa/profile-page/profile-page.component').then(m => m.ProfilePageComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'card',
        loadComponent: () =>
          import('./dashboard-visa/credit-card/credit-card.component').then(m => m.CreditCardComponent),
        canActivate: [DashboardGuard],
      },
      { path: 'messages/create', component: NgxGfmoneyCreateMessageComponent, canActivate: [DashboardGuard] },
      { path: 'messages/view/:id', component: NgxGfmoneyMessageComponent, canActivate: [DashboardGuard] },
      { path: 'messages/:type', component: NgxGfmoneyMessagesComponent, canActivate: [DashboardGuard] },
    ],
  },
  {
    path: 'mypages',
    loadComponent: () =>
      import('./mypages/shared/components/mypages-layout/mypages-layout.component').then(m => m.MypagesLayoutComponent),
    children: [
      { path: '', redirectTo: '/dashboard-visa/login', pathMatch: 'full' },
      {
        path: 'login',
        redirectTo: '/dashboard-visa/login',
      },
      {
        path: 'home',
        loadComponent: () => import('./mypages/home-page/home-page.component').then(m => m.HomePageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'pending',
        loadComponent: () => import('./mypages/pending-page/pending-page.component').then(m => m.PendingPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'no-loan',
        loadComponent: () => import('./mypages/decline-page/decline-page.component').then(m => m.DeclinePageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'insurance',
        loadComponent: () => import('./mypages/insurance/insurance.component').then(m => m.InsuranceComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'invoices',
        loadComponent: () =>
          import('./mypages/invoices-page/invoices-page.component').then(m => m.InvoicesPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'transactions',
        loadComponent: () =>
          import('./mypages/transactions-page/transactions-page.component').then(m => m.TransactionsPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'help',
        loadComponent: () => import('./mypages/help-page/help-page.component').then(m => m.HelpPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'profile',
        loadComponent: () => import('./mypages/profile-page/profile-page.component').then(m => m.ProfilePageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'account-verification',
        loadComponent: () =>
          import('./mypages/account-verification/account-verification.component').then(
            m => m.AccountVerificationComponent,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'payment-free-month',
        loadComponent: () =>
          import('./mypages/payment-free-month/payment-free-month.component').then(m => m.PaymentFreeMonthComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'credit-limit-upgrade-init',
        loadComponent: () =>
          import('./mypages/credit-limit-upgrade-init/credit-limit-upgrade-init.component').then(
            m => m.CreditLimitUpgradeInitComponent,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'credit-limit-upgrade',
        loadComponent: () =>
          import('./mypages/credit-limit-upgrade/credit-limit-upgrade.component').then(
            m => m.CreditLimitUpgradeComponent,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'transactions-check',
        loadComponent: () =>
          import('./flow/transactions-check/transactions-check.component').then(m => m.TransactionsCheckComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'transactions-check-status',
        loadComponent: () =>
          import('./mypages/transactions-check-status/transactions-check-status.component').then(
            m => m.TransactionsCheckStatusComponent,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'customer-details-renew',
        loadComponent: () =>
          import('./mypages/customer-details/customer-details.component').then(m => m.CustomerDetailsComponent),
        canActivate: [AuthGuard],
      },
      { path: 'messages/create', component: NgxGfmoneyCreateMessageComponent, canActivate: [AuthGuard] },
      { path: 'messages/view/:id', component: NgxGfmoneyMessageComponent, canActivate: [AuthGuard] },
      { path: 'messages/:type', component: NgxGfmoneyMessagesComponent, canActivate: [AuthGuard] },
    ],
    providers: [
      importProvidersFrom(
        NgxGfmoneyMessagesModule.forRoot({
          allowedFileTypes: 'image/jpeg,image/png,.pdf,.txt',
          apiUrl: `${environment.apiHost}`,
          brand: environment.companyName,
          dateFormat: 'yyyy-MM-dd HH:mm',
          homePagePath: '/mypages',
        }),
      ),
    ],
  },
  {
    path: '**',
    loadComponent: () => import('./flow/error/error.component').then(m => m.ErrorComponent),
  },
]
